// extracted by mini-css-extract-plugin
export var chatHtmlText = "_uf-2";
export var chatLink = "_uf-0";
export var chatText = "_uf-1";